export const FETCH_CREATE_PROJECT_REQUEST = 'FETCH_CREATE_PROJECT_REQUEST'
export const FETCH_CREATE_PROJECT_SUCCESS = 'FETCH_CREATE_PROJECT_SUCCESS'
export const FETCH_CREATE_PROJECT_FALUIRE = 'FETCH_CREATE_PROJECT_FALUIRE'
